// import {jsonToRoutesConfig} from '../../api/translate';
import {jsonToRoutesConfig} from '../../api/translate';
export interface NavItemProps {
  id: string;
  messageId: string;
  title: string;
  icon?: string;
  exact?: boolean;
  url?: string;
  type?: string;
  count?: number;
  color?: string;
  auth?: string[];
  actions?: any; // | NavItemProps;
  children?: NavItemProps[]; // | NavItemProps;
  parentId?: string | undefined;
}

export interface FormLabels {
  id: number;
  labels: {
    id: string;
    name: string;
    hasAccess?: boolean | undefined;
    type?: string | number | undefined;
  }[];
}

const routesConfig: NavItemProps[] = jsonToRoutesConfig('fa');

export default routesConfig;
